// App.js
import { Routes, Route } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import ScrollToTop from "Helpers/ScrollToTop";
import Lenis from "lenis";
import Header from "Layout/Header/Header";
import Footer from "Layout/Footer/Footer";

import Home from "Pages/Home/Home";
// about
import CompanyProfile from "Pages/About/CompanyProfile/CompanyProfile";
import Awards from "Pages/About/Awards/Awards";
import Team from "Pages/About/Team/Team";
import ISO from "Pages/About/ISO/ISO";
// segment
import SegmentDetailed from "Pages/Segment/Lighting/SegmentDetailed.jsx";
// products
import ProductsMainPage from "Pages/Products/ProductsMainPage";
import Products from "Pages/Products/Products/Products";
import ProductDetails from "Pages/Products/Products/ProductDetails/ProductDetails";
import RequestForm from "Pages/RequestForm/RequestForm.jsx";
// services
import ServiceMainPage from "Pages/Services/ServiceMainPage";
// projects
import ProjectsMainPage from "Pages/Projects/ProjectsMainPage/ProjectsMainPage";
import ProjectDetails from "Pages/Projects/ProjectDetailes/ProjectDetails";
// not found
import NotFound from "Pages/NotFound/NotFound";
// academy
import AcademyMainPage from "Pages/Academy/AcademyMainPage";
import PastCourses from "Pages/Academy/TraniningAndWorkShop/DetailsCourses/PastCourses/PastCourses";
import UppcomingCourses from "Pages/Academy/TraniningAndWorkShop/DetailsCourses/uppcomingCourses/UppcomingCourses";
// news
import MainNews from "Pages/News/MainNews";
import NewsDetails from "Pages/News/NewsDetails/NewsDetails";
// carrers
import Carrer from "Pages/Carrers/Carrer";
import JobDetails from "Pages/Carrers/JobDetails/JobDetails.jsx";

import Contact from "Pages/Contact/Contact";

const App = () => {
  const lenisRef = useRef(null);

  useEffect(() => {
    // Initialize Lenis with faster scrolling settings
    const lenis = new Lenis({
      lerp: 0.6,
      smoothTouch: false,
    });
    lenisRef.current = lenis;

    // Request animation frame for smooth scrolling
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      {/* Pass lenisRef to ScrollToTop */}
      <ScrollToTop lenis={lenisRef.current} />
      <Header />
      <Routes>
        <Route index element={<Home />} />
        <Route path="/market-segments/:slug" element={<SegmentDetailed />} />

        <Route path="/company-profile" element={<CompanyProfile />} />
        <Route path="/awards-and-certification" element={<Awards />} />
        <Route path="/our-team" element={<Team />} />
        <Route path="/ISO" element={<ISO />} />

        <Route path="/main-products" element={<ProductsMainPage />} />
        <Route path="/products/:slug" element={<Products />} />
        <Route path="/detailed-product/:slug" element={<ProductDetails />} />
        <Route path="/request-form" element={<RequestForm />} />

        <Route path="/services" element={<ServiceMainPage />} />

        <Route path="/carrers" element={<Carrer />} />
        <Route path="/carrers_job_details/:slug" element={<JobDetails />} />

        <Route path="/main-projects" element={<ProjectsMainPage />} />
        <Route path="/projects/:slug" element={<ProjectDetails />} />

        <Route path="/academy" element={<AcademyMainPage />} />
        <Route path="/academy/past_courses/:slug" element={<PastCourses />} />
        <Route
          path="/academy/upcoming_courses/:slug"
          element={<UppcomingCourses />}
        />

        <Route path="/news" element={<MainNews />} />
        <Route path="/news/:slug" element={<NewsDetails />} />

        <Route path="/contact-us" element={<Contact />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
